import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "../../components";
import { useAppContext } from "../../context/state";
import { useRequest } from "../../utils";
import { useHistory } from "react-router-dom";
//locall
// import "./ShowComments.css";

const GetAdminUsers = (props) => {
  let history = useHistory();

  const [
    get_dashboard_users_error,
    get_dashboard_users_loading,
    get_dashboard_users_data,
    get_dashboard_users_function,
  ] = useRequest({
    method: "get",
    url: "/get_dashboard_users",
  });

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <button
          onClick={() => history.push("/dashboard/addDashboardUser/")}
          style={{ marginTop: "1rem", marginRight: "12px" }}
          type="button"
          class="btn btn-success mr-1 mb-1 "
        >
          افزودن کاربر جدید
        </button>
        {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}
        {get_dashboard_users_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">نام کاربری</th>
                <th className="table--title">سطح دسترسی</th>
                {/* <th className="table--title">نام محصول</th>
                <th className="table--title">متن نظر</th>
                <th className="table--title">امتیاز</th>
                <th className="table--title">عملیات</th> */}
                <th className="table--title">عملیات</th>
              </tr>
            )}
            Tbody={() =>
              get_dashboard_users_data.data.map((item) => (
                <tr>
                  <td>{item.user_name}</td>
                  <td>{item.roll}</td>
                  <td>
                    <Link
                      to={
                        "/dashboard/days/" +
                        item._id +
                        "/terms/" +
                        props.match.params.id
                      }
                    >
                      <button
                        type="button"
                        class="btn btn-dark round mr-1 mb-1 btn-sm"
                      >
                        ویرایش
                      </button>
                    </Link>
                  </td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { GetAdminUsers };
